import { Grid, IconButton, Typography, useTheme } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
export interface CorporateProps {
  closeDrawer?: Function;
  corpData?: any;
}
const ViewCorporateUser = (props: CorporateProps) => {
  const { closeDrawer, corpData } = props;

  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Grid height={"100%"}>
      <Grid
        width={"100%"}
        height={"15%"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        px={4}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
        >
          Corporate User
        </Typography>
        <IconButton
          aria-label="delete"
          onClick={
            closeDrawer
              ? () => {
                  closeDrawer(false);
                  navigate("/corporate");
                }
              : () => {}
          }
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid height={"85%"} padding={3} overflow={"auto"}>
        <Grid item xs={12}>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                First Name{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.firstName ? corpData.firstName : "-"}
                {/* {updateVoucherFormState.firstName
                    ? updateVoucherFormState.firstName
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqFirstName
                    ? updateVoucherFormState.reqFirstName
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.dirFName
                    ? updateVoucherFormState.dirFName
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Last Name{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.lastName ? corpData.lastName : "-"}
                {/* {updateVoucherFormState.lastName
                    ? updateVoucherFormState.lastName
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqLastName
                    ? updateVoucherFormState.reqLastName
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Access ID{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.access_id ? corpData.access_id : "-"}
                {/* {updateVoucherFormState.access_id
                    ? updateVoucherFormState.access_id
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqAccess_id
                    ? updateVoucherFormState.reqAccess_id
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Gender{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.gender ? corpData.gender : "-"}
                {/* {updateVoucherFormState.gender
                    ? updateVoucherFormState.gender
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqGender
                    ? updateVoucherFormState.reqGender
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Occupation{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.occupation ? corpData.occupation : "-"}
                {/* {updateVoucherFormState.occupation
                    ? updateVoucherFormState.occupation
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqOccupation
                    ? updateVoucherFormState.reqOccupation
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          {/* <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Unit No{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.unit_number ? corpData.unit_number : "-"}
             
              </Typography>
            </Grid>
          </Grid> */}
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Street Address{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.streetAddress ? corpData.streetAddress : "-"}

                {/* {updateVoucherFormState.address_one
                    ? updateVoucherFormState.address_one
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqAddress_one
                    ? updateVoucherFormState.reqAddress_one
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Zip Code{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.zipCode ? corpData.zipCode : "-"}
                {/* {updateVoucherFormState.zip
                    ? updateVoucherFormState.zip
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqZip
                    ? updateVoucherFormState.reqZip
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Country{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.country ? corpData.country : "-"}
                {/* {updateVoucherFormState.country_of_residence
                    ? updateVoucherFormState.country_of_residence
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqCountry_of_residence
                    ? updateVoucherFormState.reqCountry_of_residence
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Mobile{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.mobile ? corpData.mobile : "-"}
                {/* {updateVoucherFormState.mobile
                    ? updateVoucherFormState.mobile
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqMobile
                    ? updateVoucherFormState.reqMobile
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Birth Date{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.birthDate ? corpData.birthDate : "-"}
                {/* {updateVoucherFormState.dob_date
                    ? updateVoucherFormState.dob_date
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqDob_date
                    ? updateVoucherFormState.reqDob_date
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Email{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.email ? corpData.email : "-"}
                {/* {updateVoucherFormState.corporate_email
                    ? updateVoucherFormState.corporate_email
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqCorporate_email
                    ? updateVoucherFormState.reqCorporate_email
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          {/* <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Sub Type{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.subType ? corpData.subType : "-"}
                {updateVoucherFormState.id ? updateVoucherFormState.id : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqId
                    ? updateVoucherFormState.reqId
                    : "-"}
              </Typography>
            </Grid>
          </Grid> */}
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Company Name{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.companyName ? corpData.companyName : "-"}
                {/* {updateVoucherFormState.company_name
                    ? updateVoucherFormState.company_name
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqCompany_name
                    ? updateVoucherFormState.reqCompany_name
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Office Building{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.officeBuilding ? corpData.officeBuilding : "-"}
                {/* {updateVoucherFormState.office_building
                    ? updateVoucherFormState.office_building
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqOffice_building
                    ? updateVoucherFormState.reqOffice_building
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Status{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.Status ? corpData.Status : "-"}
                {/* {updateVoucherFormState.customer_status
                    ? updateVoucherFormState.customer_status
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqCustomer_status
                    ? updateVoucherFormState.reqCustomer_status
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} display={"flex"} alignItems={"center"} mb={1}>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newFilterGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                Created Date{" "}
              </Typography>
            </Grid>
            <Grid width={"3%"}>
              <Typography>:</Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  fontSize: theme.font?.fontSize.tableHeader,
                }}
              >
                {corpData.createdDate ? corpData.createdDate : "-"}
                {/* {updateVoucherFormState.createDate
                    ? updateVoucherFormState.createDate
                    : "-"}
                  {"    <|>     "}
                  {updateVoucherFormState.reqCreateDate
                    ? updateVoucherFormState.reqCreateDate
                    : "-"} */}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ViewCorporateUser;
